import React from 'react';
import styled from 'styled-components';

import Typography from 'kingpin/atoms/Typography';

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: 100%;
  padding: 16px;
`;

// A gadget whose data request failed (after its retry). Shown in place of the
// loading skeleton, so a failed gadget doesn't look like it's still loading.
// Scheduled exports look for its testId (PRINT_ERROR_SELECTOR) to retry the
// render; keep the two in sync.
const GadgetLoadError = ({
  message = "Couldn't load this table",
}: {
  message?: string;
}) => (
  <Wrapper data-testid="gadget-load-error">
    <Typography.Body type="Body 12" color="var(--color-text-secondary)">
      {message}
    </Typography.Body>
    <Typography.Body type="Body 12" color="var(--color-text-tertiary)">
      Try refreshing the page
    </Typography.Body>
  </Wrapper>
);

export default GadgetLoadError;
